import { DEVICE, DISPLAY } from './types';
import { MAIN_ACTIONS } from './types';

const initialState = {
    parentWidth: null,
    parentHeight: null,
    mainWidth: null,
    mainHeight: null,
    device: DEVICE.DESKTOP,
    iFrameMode: DISPLAY.NONE,
    location: null,
    isWidgetLayerEnabled: false,
    isPopupLayerEnabled: false
};

const reducer = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case MAIN_ACTIONS.INIT:
            return {
                parentWidth: action.data.parentWidth
                    ? action.data.parentWidth
                    : state.parentWidth,
                parentHeight: action.data.parentHeight
                    ? action.data.parentHeight
                    : state.parentHeight,
                mainWidth: action.data.mainWidth
                    ? action.data.mainWidth
                    : state.mainWidth,
                mainHeight: action.data.mainHeight
                    ? action.data.mainHeight
                    : state.mainHeight,
                device: action.data.device ? action.data.device : state.device,
                iFrameMode: action.data.iFrameMode
                    ? action.data.iFrameMode
                    : state.iFrameMode,
                location: action.data.location,
                isWidgetLayerEnabled: action.data.isWidgetLayerEnabled
                    ? action.data.isWidgetLayerEnabled
                    : state.isWidgetLayerEnabled,
                isPopupLayerEnabled: action.data.isPopupLayerEnabled
                    ? action.data.isPopupLayerEnabled
                    : state.isPopupLayerEnabled
            };
        case MAIN_ACTIONS.ENABLE_WIDGET_LAYER:
            return {
                ...state,
                isWidgetLayerEnabled: true
            };
        case MAIN_ACTIONS.ENABLE_POPUP_LAYER:
            return {
                ...state,
                isPopupLayerEnabled: true
            };
        case MAIN_ACTIONS.DISABLE_WIDGET_LAYER:
            return {
                ...state,
                isWidgetLayerEnabled: false
            };
        case MAIN_ACTIONS.DISABLE_POPUP_LAYER:
            return {
                ...state,
                isPopupLayerEnabled: false
            };
        case MAIN_ACTIONS.SET_CHILD_IFRAME_MODE:
            return {
                ...state,
                iFrameMode: action.data.iFrameMode
            };
        case MAIN_ACTIONS.UPDATE_PARENT_SIZE:
            return {
                ...state,
                device: action.data.device,
                parentWidth: action.data.parentWidth,
                parentHeight: action.data.parentHeight
            };
        case MAIN_ACTIONS.UPDATE_MAIN_SIZE:
            return {
                ...state,
                mainWidth: action.data.mainWidth,
                mainHeight: action.data.mainHeight
            };
        default:
            return state;
    }
};

export default reducer;
